import { BaseService } from "./base";

interface UploadResponse {
  uri: string;
}

class ArquivosService extends BaseService {
  constructor() {
    super("arquivos");
  }

  create(format: string): Promise<string> {
    return this.post<UploadResponse>("upload", undefined, { format }).then(
      (res) => res.uri
    );
  }
}

export default new ArquivosService();
